import { Divider } from '@mui/material';
import CopyTokenButton from '../CopyTokenButton';
import UsageContainer from '../UsageContainer';
import AccountTypeLabel from '../AccountTypeLabel';
import { AppResponse } from '../../../../api/userApi';
import {
  StyledAppHeader,
  StyledAppInner,
  StyledKeyTitle,
  StyledCurrentUsageTypography,
  StyledFormContainer,
  StyledUsageContainerWrapper,
  StyledHeaderAndLabelWrapper,
  StyledSecretKeyField,
  StyledSecretKeyWrapper,
  StyledKeyDescription,
  StyledSecretKeyContainer,
  StyledAppSubHeader,
  StyledAppHeaderContainer,
} from './styled';

interface UserAppProps {
  app: AppResponse;
  onError: (msg: string) => void;
}

const UserApp = ({ app: { name, apikey }, onError }: UserAppProps) => (
  <StyledFormContainer>
    <StyledAppHeaderContainer>
      <StyledAppHeader title={name}></StyledAppHeader>
      <StyledAppSubHeader>Your AI music generation API</StyledAppSubHeader>
    </StyledAppHeaderContainer>
    <StyledAppInner>
      <StyledSecretKeyContainer>
        <StyledKeyTitle>API Key</StyledKeyTitle>
        <StyledSecretKeyWrapper>
          <StyledSecretKeyField
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
            defaultValue={apikey}
          />
          <CopyTokenButton apiKey={apikey} onError={onError} />
        </StyledSecretKeyWrapper>
        <StyledKeyDescription>
          Keep this key secret. Do not share it in publicly accessible areas
          such as GitHub, client-side code, etc.
        </StyledKeyDescription>
      </StyledSecretKeyContainer>
      <Divider />
      <StyledUsageContainerWrapper>
        <StyledHeaderAndLabelWrapper>
          <StyledCurrentUsageTypography>
            Current Usage
          </StyledCurrentUsageTypography>
          <AccountTypeLabel />
        </StyledHeaderAndLabelWrapper>
        <UsageContainer apiKey={apikey} />
      </StyledUsageContainerWrapper>
    </StyledAppInner>
  </StyledFormContainer>
);

export default UserApp;
